<li
  class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-indigo-600 hover:text-white"
  data-testid="container"
>
  <div class="flex items-center justify-between font-normal">
    <div class="mr-3 flex items-center truncate">
      <aw-country-flag class="mr-3 h-6 w-6" [country]="item.code" />

      <span
        class="block truncate"
        [ngClass]="{
          'font-semibold': selected
        }"
        data-testid="countryName"
      >
        {{ item.name }}
      </span>
    </div>

    <span class="block" data-testid="prefix">
      {{ item.prefix }}
    </span>
  </div>
</li>
